export default "__VITE_ASSET__D8B9LTCL__"